export const state = () => ({
  header: null,
  commonHeader: null,
  footer: null,
  banner: null,
  maintenanceBanner: null,
  websiteSettings: null,
  switchMaintenanceContent: null,
  isProspectSwitchJourneyEnabled: null,
  isWebsiteBeMaintenanceEnabled: null,
  isCotMoveOutJourneyEnabled: null,
  isContentFetched: false
})

const parseFlag = flagEnvironmentToggles =>
  flagEnvironmentToggles.includes(process.env.targetEnv)

export const mutations = {
  SET_HEADER(state, header) {
    state.header = header
  },
  SET_COMMON_HEADER(state, header) {
    state.commonHeader = header
  },
  SET_FOOTER(state, footer) {
    state.footer = footer
  },
  SET_BANNER(state, banner) {
    state.banner = banner
  },
  SET_MAINTENANCE_BANNER(state, maintenanceBanner) {
    state.maintenanceBanner = maintenanceBanner
  },
  SET_WEBSITE_SETTINGS(state, websiteSettings) {
    state.websiteSettings = websiteSettings
  },
  SET_PROSPECT_SWITCH_JOURNEY_STATUS(state, isProspectSwitchJourneyEnabled) {
    state.isProspectSwitchJourneyEnabled = isProspectSwitchJourneyEnabled
  },
  SET_PROMOTE_RENEWAL_STATUS(state, promoteRenewal) {
    state.isPromoteRenewalEnabled = promoteRenewal
  },
  SET_SWITCH_JOURNEY_MAINTENANCE_CONTENT(state, switchMaintenanceContent) {
    state.switchMaintenanceContent = switchMaintenanceContent
  },
  SET_WEBSITE_BE_MAINTENANCE_STATUS(state, websiteBeMaintenance) {
    state.isWebsiteBeMaintenanceEnabled = parseFlag(websiteBeMaintenance)
  },
  SET_COT_MOVE_OUT_JOURNEY_STATUS(state, isCotMoveOutJourneyEnabled) {
    state.isCotMoveOutJourneyEnabled = parseFlag(isCotMoveOutJourneyEnabled)
  },
  SET_CONTENT_FETCHED_FLAG(state, isContentFetched) {
    state.isContentFetched = isContentFetched
  },
  SET_COOKIE_MODAL(state, banner) {
    state.cookieModal = banner
  },
  SET_COOKIE_BANNER(state, banner) {
    state.cookieBanner = banner
  }
}

export const actions = {
  async fetchSwitchJourneyContent({ commit }) {
    const { story } = await this.$storyblokHelper.get({
      id: "quote-and-switch"
    })
    commit("SET_SWITCH_JOURNEY_MAINTENANCE_CONTENT", story.content)
  },
  async fetchLayoutContent({ state, commit, dispatch }, noCache) {
    if (state.isContentFetched) return

    const [
      { stories },
      { story: commonHeader },
      { story: websiteSettings },
      { story: commonSettings },
      { story: commonCookieModal },
      { story: commonCookieBanner }
    ] = await Promise.all([
      this.$storyblokHelper.get({
        starts_with: "layout/"
      }),
      this.$storyblokHelper.get({
        id: "common/header"
      }),
      this.$storyblokHelper.get({
        id: "website/website-settings"
      }),
      this.$storyblokHelper.get({
        id: "common/settings"
      }),
      this.$storyblokHelper.get({
        id: "common/cookie-modal"
      }),
      this.$storyblokHelper.get({
        id: "common/cookie-banner"
      })
    ])

    const switchJourneyEnabled = parseFlag(
      commonSettings.content.prospectSwitchJourney
    )
    if (!switchJourneyEnabled) await dispatch("fetchSwitchJourneyContent")

    const header = stories.find(story => story.slug === "header")
    const footer = stories.find(story => story.slug === "footer")
    const banner = stories.find(story => story.slug === "global-banner")
    const maintenanceBanner = stories.find(
      story => story.slug === "maintenance-banner"
    )
    commit("SET_HEADER", header)
    commit("SET_COMMON_HEADER", commonHeader)
    commit("SET_FOOTER", footer)
    commit("SET_BANNER", banner)
    commit("SET_MAINTENANCE_BANNER", maintenanceBanner)
    commit("SET_WEBSITE_SETTINGS", websiteSettings)
    commit("SET_PROSPECT_SWITCH_JOURNEY_STATUS", switchJourneyEnabled)
    commit(
      "SET_PROMOTE_RENEWAL_STATUS",
      commonSettings.content.promoteRenewal.includes(process.env.targetEnv)
    )
    commit(
      "SET_WEBSITE_BE_MAINTENANCE_STATUS",
      commonSettings.content.websiteBeMaintenance
    )
    commit(
      "SET_COT_MOVE_OUT_JOURNEY_STATUS",
      commonSettings.content.cotMoveOutJourneyEnabled
    )
    if (!noCache) {
      commit("SET_CONTENT_FETCHED_FLAG", true)
    }
    commit("SET_COOKIE_MODAL", commonCookieModal)
    commit("SET_COOKIE_BANNER", commonCookieBanner)
  },
  applyPreviewChanges({ commit, state }, story) {
    if (story.id === state.header.id) {
      commit("SET_HEADER", story)
    } else if (story.id === state.footer.id) {
      commit("SET_FOOTER", story)
    } else if (story.id === state.banner.id) {
      commit("SET_BANNER", story)
    } else if (story.id === state.websiteSettings.id) {
      commit("SET_WEBSITE_SETTINGS", story)
    }
  }
}

export const getters = {
  header: store => store.commonHeader && store.commonHeader.content,
  footer: store => store.footer && store.footer.content,
  globalBanner: store => store.banner && store.banner.content,
  maintenanceBanner: store =>
    store.maintenanceBanner && store.maintenanceBanner.content,
  websiteSettings: store =>
    store.websiteSettings && store.websiteSettings.content,
  cookieModal: store => store.cookieModal && store.cookieModal.content,
  cookieBanner: store => store.cookieBanner?.content
}
